import Text from 'components/_core/Text';
import AccountSetupCircularProgress from 'features/PostOnboardingAccountSetup/components/AccountSetupCircularProgress';
import { usePostOnboardingAccountSetupContext } from 'features/PostOnboardingAccountSetup/context';

import { NavigationHighlightBlock } from '../NavigationHighlightBlock';
import locales from './locales';

export function AccountSetupBox() {
  const { loading, progressLabel, progressValue } =
    usePostOnboardingAccountSetupContext();

  if (loading) {
    return null;
  }

  return (
    <NavigationHighlightBlock to="/account-setup">
      <AccountSetupCircularProgress
        progress={progressValue}
        progressLabel={progressLabel}
        size="32px"
        textSize="xs"
        textWeight="weight-400"
        trackColor="grey.400"
      />
      <Text lineHeight="20px" size="sm" variant="primary">
        {locales.title}
      </Text>
    </NavigationHighlightBlock>
  );
}
